import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from 'vue';
import i18n from '@/i18n';

export interface OpenButtonStyle {
  position?: string;
  left?: string;
  background: string;
  'border-radius': string;
  'border-width': string;
  width: string;
  height: string;
  'font-size': string;
  color: string;
  'text-decoration-line': string;
  'text-align'?: string;
}

export interface RealButtonStyle {
  'font-size': string;
  color: string;
  'text-decoration-line': string;
}

interface OpenButtonProps {
  openBtnStyleObj: OpenButtonStyle;
  downloadBtnText: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadAppButton',
  props: {
    openBtnStyleObj: {},
    downloadBtnText: { default: i18n.global.t('common.download') }
  },
  emits: ['actionDownload'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = __props;

// const openButtonStyle = computed(() => {
//   return {
//     ...props.openBtnStyleObj,
//   } as CSSProperties;
// });

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function proxyOpen(event: any) {
  event.stopPropagation();
  downloadAction();
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function commonDownload(event: any) {
  event.stopPropagation();
  downloadAction();
}

function downloadAction() {
  emit('actionDownload');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "frame",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (proxyOpen($event)))
  }, [
    _createElementVNode("button", {
      class: "actionButton",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (commonDownload($event)))
    }, _toDisplayString(_ctx.downloadBtnText), 1)
  ]))
}
}

})